/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import React from "react";
import MaterialRequestDetailsApp from "../../../Functionality/MaterialRequest/MaterialRequestDetailsApp";
import {ENTRY_AND_EXIT_FORMS} from "../../../Model/Model";
import {permissionObj} from "../../../../../../Helpers/permission";
import GeneralEntryExitDetails from "../../EntryAndExitForms/GeneralEntryExit/Details/GeneralEntryExitDetails";
import PlantMaterialControlDetails from "../../EntryAndExitForms/PlantMaterialControl/Details/PlantMaterialControlDetails";
import CratesAndPalletsReturnDetails from "../../EntryAndExitForms/CratesAndPalletsReturn/Details/CratesAndPalletsReturnDetails";
import PoultryTruckExitDetails from "../../EntryAndExitForms/PoultryTruckExit/Details/PoultryTruckExitDetails";
import LivePoultryTruckDetails from "../../EntryAndExitForms/LivePoultryTruck/Details/LivePoultryTruckDetails";

/**
 * Detail of a request of material control.
 *
 * A request is registered with one of the entry and exit forms, so the detail is
 * read once and the type of the form tells which detail is displayed for it, the
 * same way the forms tab reads the detail of a movement.
 *
 * @returns {JSX.Element} Detail of the request matching the type of its form.
 */
const MaterialRequestDetails = () => {
    const {
        t,
        navigate,
        DEV,
        permission,
        contentCardRef,
        contentTableRef,
        containerCardRef,
        containerTableRef,
        item,
        goBack,
        evidence,
        form,
        statusId,
        movementDirectionOption,
        movementDirectionSection,
        pendingGateTrans,
        showBadge
    } = MaterialRequestDetailsApp();

    const DetailsByForm = {
        [ENTRY_AND_EXIT_FORMS.PLANT_MATERIAL_CONTROL.key]: PlantMaterialControlDetails,
        [ENTRY_AND_EXIT_FORMS.CRATES_AND_PALLETS_RETURN.key]: CratesAndPalletsReturnDetails,
        [ENTRY_AND_EXIT_FORMS.POULTRY_TRUCK_EXIT.key]: PoultryTruckExitDetails,
        [ENTRY_AND_EXIT_FORMS.LIVE_POULTRY_TRUCK.key]: LivePoultryTruckDetails
    };

    const Details = DetailsByForm[form?.key] || GeneralEntryExitDetails;

    return (
        <Details
            t={t}
            navigate={navigate}
            DEV={DEV}
            permission={permission}
            contentCardRef={contentCardRef}
            contentTableRef={contentTableRef}
            containerCardRef={containerCardRef}
            containerTableRef={containerTableRef}
            item={item}
            evidence={evidence}
            form={form}
            statusId={statusId}
            movementDirectionOption={movementDirectionOption}
            movementDirectionSection={movementDirectionSection}
            showBadge={showBadge}
            pendingGateTrans={pendingGateTrans}
            readPermission={permissionObj.WEB_MATERIAL_CONTROL_REQUEST_READ}
            goBack={goBack}
        />
    );
};

export default MaterialRequestDetails;
